export default __webpack_public_path__ + "static/media/phone2.ca80bb79.png";